// extracted by mini-css-extract-plugin
export default {"product":"ProductItem_product__nL+kf","price":"ProductItem_price__bO4cX"};